/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "apiTagTable",
            "endpoint": "https://m3ahgmiiog.execute-api.us-east-2.amazonaws.com/dev",
            "region": "us-east-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-2:404bd2d5-3d65-4cd1-bc2f-3eee6caaf377",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_4XUA6e3OD",
    "aws_user_pools_web_client_id": "7tq3088ihjivmiptl50bu90ri3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Fingerprint-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "Plaid-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        },
        {
            "tableName": "Tag-4l3liz36mvhohjid6satkgmksm-dev",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
